import gql from "graphql-tag";

export default gql`
  query Graphicsets($offset: Int, $limit: Int, $customerId: ID, $orderByName: String) {
    graphicsets(offset: $offset, limit: $limit, customerId: $customerId, orderByName: $orderByName) {
      items {
        id
        name
        description
        customerId
        hasEvents
        layouts {
          asset {
            id
            customerId
            format
            sizePx {
              x
              y
            }
          }
        }
      }
      total
    }
  }
`;
